import { useMemo, useState, type ReactElement, type ReactNode } from 'react';
import { SearchCombobox } from '../../shared/components/search-combobox/search-combobox.tsx';

export type SearchSelectProps<T> = {
    className?: string;
    disabled?: boolean;
    idSelector: (value: T) => string;
    items?: T[];
    isLoading?: boolean;
    onSelectedIdChange?: (id: string) => void;
    placeholder?: string;
    renderItem: (value: T) => ReactNode;
    selectedId?: string;
    textSelector: (value: T) => string;
};

export function SearchSelect<T extends object>({
    className,
    disabled,
    idSelector,
    isLoading,
    items,
    onSelectedIdChange,
    placeholder,
    renderItem,
    selectedId,
    textSelector,
}: SearchSelectProps<T>): ReactElement {
    const [query, setQuery] = useState('');

    const groupedItems = useMemo(() => {
        const lowerQuery = query.toLowerCase();
        const filtered = items?.filter((item) => textSelector(item).toLowerCase().includes(lowerQuery));
        return [{ id: '1', items: filtered ?? [] }];
    }, [items, query, textSelector]);

    return (
        <SearchCombobox<T>
            className={className}
            isLoading={isLoading ?? false}
            groupedItems={groupedItems}
            notFoundPlaceholder={''}
            inputPlaceholder={placeholder ?? ''}
            keySelector={idSelector}
            onSearchQueryChange={setQuery}
            valueSelector={idSelector}
            renderItem={renderItem}
            searchQuery={query}
            onValueChange={(id) => {
                onSelectedIdChange?.(id);
            }}
            selectedValue={selectedId ?? ''}
            disabled={disabled}
        />
    );
}
